import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

function CreateSettings() {
    const [settingKey, setSettingKey] = useState('');
    const [settingValue, setSettingValue] = useState('');
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            await axios.post(process.env.REACT_APP_API_URL + 'settings', {
                setting_key: settingKey,
                setting_value: settingValue
            });
            navigate('/settingslist');
        } catch (error) {
            console.error(error);
        }
    };

    return (
        <div className='container mt-4'>
            <h4>Add Setting</h4>
            <form onSubmit={handleSubmit}>
                <div className='mb-3'>
                    <label className='form-label'>Setting Key</label>
                    <input
                        type='text'
                        className='form-control'
                        value={settingKey}
                        onChange={(e) => setSettingKey(e.target.value)}
                        required
                    />
                </div>
                <div className='mb-3'>
                    <label className='form-label'>Setting Value</label>
                    <input
                        type='text'
                        className='form-control'
                        value={settingValue}
                        onChange={(e) => setSettingValue(e.target.value)}
                        required
                    />
                </div>
                <button type='submit' className='btn btn-primary'>Save</button>
                <button type='button' className='btn btn-secondary ms-2' onClick={() => navigate('/settingslist')}>Cancel</button>
            </form>
        </div>
    );
}

export default CreateSettings;